export default [
  {
    path: '/dataStatistics/userConsumeRank',
    component: () =>
      import('../pages/memberCardManage/dataStatistics/userConsumeRank.vue'),
    name: 'userConsumeRank',
    title: '用户使用排名',
    meta: {
      title: '用户使用排名',
    },
  },
  {
    path: '/dataStatistics/storeConsumeRank',
    component: () =>
      import('../pages/memberCardManage/dataStatistics/storeConsumeRank.vue'),
    name: 'storeConsumeRank',
    title: '商家销售排名',
    meta: {
      title: '商家销售排名',
    },
  },
  {
    path: '/dataStatistics/cardTypeSaleRank',
    component: () =>
      import('../pages/memberCardManage/dataStatistics/cardTypeSaleRank.vue'),
    name: 'cardTypeSaleRank',
    title: '卡型销售排名',
    meta: {
      title: '卡型销售排名',
    },
  },
  {
    path: '/dataStatistics/cardChannelSaleRank',
    component: () =>
      import(
        '../pages/memberCardManage/dataStatistics/cardChannelSaleRank.vue'
      ),
    name: 'cardChannelSaleRank',
    title: '渠道销售排名',
    meta: {
      title: '渠道销售排名',
    },
  },
]
